import type React from 'react'
import styled from 'styled-components'

import type { ButtonBaseProps } from './ButtonBase'
import TextButton from './TextButton'

interface ButtonWithIconProps extends ButtonBaseProps {
  startIcon?: NonNullable<React.ReactNode>
  endIcon?: NonNullable<React.ReactNode>
}

const StyledTextButton = styled(TextButton)`
  display: flex;
  align-items: center;
  gap: 5px;
`

const IconWrapperSpan = styled.span`
  display: inherit;
  align-items: inherit;
`

export function TextButtonWithIcon({ startIcon, endIcon, children, ...props }: ButtonWithIconProps) {
  return (
    <StyledTextButton {...props}>
      <>
        {startIcon && <IconWrapperSpan>{startIcon}</IconWrapperSpan>}
        {children}
        {endIcon && <IconWrapperSpan>{endIcon}</IconWrapperSpan>}
      </>
    </StyledTextButton>
  )
}
